import DataLoader from 'components/program/DataLoader';
import Shows from 'components/program/Shows';
import UserSettings from 'lib/types/UserSettings';
import styles from "./FilmProgram.module.css";


//#region [Props]
type FilmProgramProps = {
    edi: string;
    nynorsk?: boolean;
    isKinoklubb: boolean;
    userSettings?: UserSettings;
    isPremiereInFuture?: boolean;
};
//#endregion

//#region [Component]
export default function FilmProgram({ edi, nynorsk = false, isKinoklubb, userSettings, isPremiereInFuture }: FilmProgramProps) {
    return <section className={styles.FilmProgram}>
        <h1 className={styles.ProgramTitle}>{nynorsk ? "Framsyningar" : "Forestillinger"}</h1>
        <DataLoader className={styles.DataLoader} edi={edi} loaderText={`Henter ${nynorsk ? "framsyninar" : "forestillinger"}`} skipDocuments userSettings={userSettings} isPremiereInFuture={isPremiereInFuture}>
            <Shows isKinoklubb={isKinoklubb} />
        </DataLoader>
    </section>;
}
//#endregion
